import AutoAdvance from './autoAdvance'
import Dropdown from './dropdown'
import PhoneField from './phoneField'

const install = Alpine => {
    Alpine.data('autoAdvance', AutoAdvance)
    Alpine.data('dropdown', Dropdown)
    Alpine.data('phoneField', PhoneField)
}

export {
    AutoAdvance,
    Dropdown,
    PhoneField,
    install,
}
